<script setup lang="ts">
defineProps<{
  isLoading?: boolean
}>()
</script>

<template>
  <tr
    class="
      group
      gap-3xs
      flex items-center
      rounded border-2 border-surface-primary bg-surface-primary
    "
    :class="!isLoading ? 'hover:bg-surface-hover hover:border-surface-hover active:bg-blurple-100 active:border-blurple-100' : undefined"
  >
    <slot />
  </tr>
</template>
